import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { about } from "@/data/siteConfig";
import { SectionHeader } from "@/components/SectionHeader";
import { MediaPlaceholder } from "@/components/MediaPlaceholder";
import { Reveal } from "@/components/Reveal";

export const AboutPreview = () => (
  <section className="grain relative bg-bone py-24 md:py-32" data-testid="about-preview">
    <div className="relative z-10 mx-auto max-w-[1440px] px-5 md:px-8">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <MediaPlaceholder
            src="/media/about-jose.jpg"
            alt="Jose Velasco of Velasco Lock and Safe with a team member and a safe on the moving trailer"
            aspect="aspect-[4/3]"
          />
        </Reveal>
        <div>
          <SectionHeader light overline="About" title={about.headline} />
          <p className="mt-6 text-lg leading-relaxed text-ink/75">{about.lead}</p>
          <p className="mt-4 leading-relaxed text-ink/60">{about.paragraphs[0]}</p>
          <Link
            to="/about"
            data-testid="about-link"
            className="group mt-8 inline-flex items-center gap-2 font-heading text-sm font-bold uppercase tracking-wide text-ink transition-colors hover:text-gold-dark"
          >
            More About Jose
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </div>
  </section>
);
